import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminCategoriesQuery.ts
var r = () => t({
	queryKey: e.categories(),
	queryFn: () => n.adminListCategories()
});
//#endregion
export { r as useAdminCategoriesQuery };
